import { cx } from '@twind/core';
import useInputFontSizeClass from 'app/hooks/useInputFontSizeClass';
import type { ChangeEventHandler, KeyboardEventHandler, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { Body, Title } from '../../../../../components/Typography';
import { ChatFormItem } from '../../../../../services/chatBot';

export default function FormChatItemInput({
  submitted,
  onKeyUp,
  onChange,
  onClickSubmit,
  onClickSkip,
  formItem,
  answerFormItem,
  hasError,
  value,
}: {
  submitted: boolean;
  onKeyUp: KeyboardEventHandler<HTMLInputElement>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClickSubmit: MouseEventHandler<HTMLButtonElement>;
  onClickSkip: MouseEventHandler<HTMLButtonElement>;
  formItem: ChatFormItem;
  answerFormItem?: ChatFormItem;
  hasError: boolean;
  value: string;
}) {
  const fontSizeClass = useInputFontSizeClass();
  const { t } = useTranslation();

  return submitted && !hasError ? (
    <Title
      key={formItem.ref_id}
      className={cx(
        'ostro-chatbot-message-form-input-submitted',
        '~(py-3 px-5 mb-3 rounded-xl block w-full text-left bg-brand-primary)'
      )}
    >
      {value}
    </Title>
  ) : (
    <div key={formItem.ref_id}>
      <input
        type="text"
        placeholder={formItem.placeholder}
        className={cx(
          'ostro-chatbot-message-form-text',
          '~(py-3 px-5 mb-3 rounded-xl block w-full border-(1 divider) focus:outline-brand-primary placeholder:text-sm)',
          hasError ? 'border-error focus:outline-error' : '',
          fontSizeClass
        )}
        onChange={onChange}
        onKeyUp={onKeyUp}
        value={value}
        autoFocus
      />
      {hasError &&
        answerFormItem?.errors?.map((error) => (
          <Body
            key={error}
            className={cx('ostro-chatbot-message-form-input-error', 'mb-3 text-error')}
          >
            {error}
          </Body>
        ))}
      <div className="text-center">
        <button
          className="ostro-chatbot-message-form-submit block w-full bg-black text-white rounded-button p-3"
          onClick={onClickSubmit}
        >
          {t('virtual_assistant.input_actions.submit')}
        </button>
        <button
          onClick={onClickSkip}
          className="underline mt-2"
        >
          {t('virtual_assistant.input_actions.skip')}
        </button>
      </div>
    </div>
  );
}
